import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ICallback } from '../../../commonTypes/hook.types';

interface GenerateToken {
    branchId?: string;
}

const useHttpGetJoinToken = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);

    const getToken = (body: GenerateToken, callback: ICallback) => {
        const { exec } = organizationApi.getJoinToken({
            body,
            onSuccess: res => {
                if (callback.onSuccess) callback.onSuccess(res.body);
            },
        });

        exec();
    };

    return { getToken };
};

export default useHttpGetJoinToken;
